import * as actionTypes from './actionTypes'
import api from '../../utils/api'
import { setJwtToken } from '../auth/authActions'

/** Performs signup for Learn Invest panel in Education portal */
export const educationLearnInvestSignup = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.EDUCATION_LEARN_INVEST_SIGNUP_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/register`, data)
      .then(res => {
        if (res?.result) {
          dispatch(setJwtToken(res?.token, 'learnInvest'))
          dispatch({
            type: actionTypes.EDUCATION_LEARN_INVEST_SIGNUP_SUCCESS,
            payload: res,
          })
        } else {
          dispatch({
            type: actionTypes.EDUCATION_LEARN_INVEST_SIGNUP_FAIL,
          })
          throw res?.error
        }
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.EDUCATION_LEARN_INVEST_SIGNUP_FAIL,
        })
        throw error
      })
  }
}

/** Performs signup with google for Learn Invest panel in Education portal */
export const educationLearnInvestSignupWithGoogle = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.EDUCATION_LEARN_INVEST_SIGNUP_GOOGLE_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/google-signup`, data)
      .then(res => {
        if (res?.result) {
          dispatch(setJwtToken(res?.token, 'learnInvest'))
          dispatch({
            type: actionTypes.EDUCATION_LEARN_INVEST_SIGNUP_GOOGLE_SUCCESS,
            payload: res,
          })
        } else {
          dispatch({
            type: actionTypes.EDUCATION_LEARN_INVEST_SIGNUP_GOOGLE_FAIL,
          })
          throw res?.error
        }
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.EDUCATION_LEARN_INVEST_SIGNUP_GOOGLE_FAIL,
        })
        throw error
      })
  }
}

/** Performs login for Learn Invest panel in Education portal */
export const educationLearnInvestLogin = (data, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.EDUCATION_LEARN_INVEST_LOGIN_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/login`, data)
      .then(res => {
        if (res?.result) {
          dispatch(setJwtToken(res?.token, 'learnInvest'))
          dispatch({
            type: actionTypes.EDUCATION_LEARN_INVEST_LOGIN_SUCCESS,
            payload: res,
          })
          onSuccess && onSuccess(res)
        } else {
          dispatch({
            type: actionTypes.EDUCATION_LEARN_INVEST_LOGIN_FAIL,
          })
          onFail && onFail(res?.error)
          throw res?.error
        }
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.EDUCATION_LEARN_INVEST_LOGIN_FAIL,
        })
        onFail && onFail(error || error?.response?.data?.error || error?.message)
        throw error
      })
  }
}

/** Performs login with google for Learn Invest panel in Education portal */
export const educationLearnInvestGoogleLogin = (data, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.EDUCATION_LEARN_INVEST_GOOGLE_LOGIN_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/google-signin`, data)
      .then(res => {
        if (res?.result) {
          dispatch(setJwtToken(res?.token, 'learnInvest'))
          dispatch({
            type: actionTypes.EDUCATION_LEARN_INVEST_GOOGLE_LOGIN_SUCCESS,
            payload: res,
          })
          onSuccess && onSuccess(res)
        } else {
          dispatch({
            type: actionTypes.EDUCATION_LEARN_INVEST_GOOGLE_LOGIN_FAIL,
          })
          onFail && onFail(res?.error)
          throw res?.error
        }
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.EDUCATION_LEARN_INVEST_GOOGLE_LOGIN_FAIL,
        })
        onFail && onFail(error?.response?.data?.error || error?.message)
        throw error
      })
  }
}

/** Fetches the user's profile data from the server */
export const fetchProfileData = (onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.FETCH_EDUCATION_LEARN_INVEST_PROFILE_DATA_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/education/profile-data`, undefined, 'learnInvest')
      .then(res => {
        if (res?.result) {
          dispatch({
            type: actionTypes.FETCH_EDUCATION_LEARN_INVEST_PROFILE_DATA_SUCCESS,
            payload: res?.data,
          })
        } else {
          dispatch({
            type: actionTypes.FETCH_EDUCATION_LEARN_INVEST_PROFILE_DATA_FAIL,
          })
          throw res?.error
        }
        onSuccess && onSuccess(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.FETCH_EDUCATION_LEARN_INVEST_PROFILE_DATA_FAIL,
        })
        onFail && onFail(error)
        throw error
      })
  }
}

/** Uploads the user's profile picture to the server */
export const uploadProfilePicture = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPLOAD_EDUCATION_LEARN_INVEST_PROFILE_PICTURE_INIT,
    })
    await api
      .postwithFormData(`${process.env.REACT_APP_API_URL}/education/mime-files`, data, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.UPLOAD_EDUCATION_LEARN_INVEST_PROFILE_PICTURE_SUCCESS,
          payload: res,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPLOAD_EDUCATION_LEARN_INVEST_PROFILE_PICTURE_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Updates the user's profile data with the provided information */
export const updateProfileData = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_EDUCATION_LEARN_INVEST_PROFILE_DATA_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/profile-data`, data, 'learnInvest')
      .then(res => {
        if (res?.result) {
          dispatch({
            type: actionTypes.UPDATE_EDUCATION_LEARN_INVEST_PROFILE_DATA_SUCCESS,
            payload: res?.data,
          })
        } else {
          dispatch({
            type: actionTypes.UPDATE_EDUCATION_LEARN_INVEST_PROFILE_DATA_FAIL,
          })
          throw res?.error
        }
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_EDUCATION_LEARN_INVEST_PROFILE_DATA_FAIL,
        })
        throw error
      })
  }
}

/** Sends a request to update the user's password */
export const updatePassword = (data, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_EDUCATION_LEARN_INVEST_PASSWORD_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/change-password`, { ...data }, 'learnInvest')
      .then(res => {
        if (res?.result) {
          dispatch({
            type: actionTypes.UPDATE_EDUCATION_LEARN_INVEST_PASSWORD_SUCCESS,
            payload: res?.data,
          })
          onSuccess && onSuccess()
        } else {
          dispatch({
            type: actionTypes.UPDATE_EDUCATION_LEARN_INVEST_PASSWORD_FAILED,
          })
          onFail && onFail()
        }
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_EDUCATION_LEARN_INVEST_PASSWORD_FAILED,
        })
        onFail && onFail()
        throw error?.response?.data?.error
      })
  }
}

/** Retrieves the user's email notification settings */
export const getEmailNotifications = onSuccess => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_EDUCATION_LEARN_INVEST_EMAIL_NOTIFICATIONS_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/education/email-notification`, undefined, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_EMAIL_NOTIFICATIONS_SUCCESS,
          payload: res?.data,
        })
        onSuccess && onSuccess(res?.data)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_EMAIL_NOTIFICATIONS_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Updates the user's email notification preferences */
export const setEmailNotifications = (data, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.SET_EDUCATION_LEARN_INVEST_EMAIL_NOTIFICATIONS_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/email-notification`, data, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.SET_EDUCATION_LEARN_INVEST_EMAIL_NOTIFICATIONS_SUCCESS,
          payload: res?.data,
        })
        onSuccess && onSuccess(res)
      })
      .catch(error => {
        dispatch({
          type: actionTypes.SET_EDUCATION_LEARN_INVEST_EMAIL_NOTIFICATIONS_FAILED,
        })
        onFail && onFail(error?.response?.data?.error || error?.message)
        throw error?.response?.data?.error
      })
  }
}

/** Retrieves the complete list of syllabus items */
export const getAllSyllabus = () => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_EDUCATION_LEARN_INVEST_SYLLABUS_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/education/get-chapters`, undefined, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_SYLLABUS_SUCCESS,
          payload: res?.data,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_SYLLABUS_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Fetches data for reading materials */
export const getReadingMaterialData = (id, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_EDUCATION_LEARN_INVEST_READING_MATERIAL_DATA_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/reading-material?id=${id}`, {}, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_READING_MATERIAL_DATA_SUCCESS,
          payload: res?.data,
        })
        onSuccess && onSuccess(res?.data)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_READING_MATERIAL_DATA_FAILED,
        })
        onFail && onFail(error?.response?.data?.error)
        throw error?.response?.data?.error
      })
  }
}

/** Marks a reading material as read */
export const markAsReadReadingMaterial = (data, id, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.MARK_AS_READ_EDUCATION_LEARN_INVEST_READING_MATERIAL_INIT,
    })
    await api
      .post(
        `${process.env.REACT_APP_API_URL}/education/reading-material?id=${id}`,
        { ...data },
        'learnInvest',
      )
      .then(res => {
        if (res?.result) {
          dispatch({
            type: actionTypes.MARK_AS_READ_EDUCATION_LEARN_INVEST_READING_MATERIAL_SUCCESS,
            payload: res?.data,
          })
          onSuccess && onSuccess()
        } else {
          dispatch({
            type: actionTypes.MARK_AS_READ_EDUCATION_LEARN_INVEST_READING_MATERIAL_FAILED,
          })
          onFail && onFail()
        }
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.MARK_AS_READ_EDUCATION_LEARN_INVEST_READING_MATERIAL_FAILED,
        })
        onFail && onFail()
        throw error?.response?.data?.error
      })
  }
}

/** Retrieves data for video lectures */
export const getVideoLecturesData = (id, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_EDUCATION_LEARN_INVEST_VIDEO_LECTURES_DATA_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/videos?id=${id}`, {}, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_VIDEO_LECTURES_DATA_SUCCESS,
          payload: res?.data,
        })
        onSuccess && onSuccess(res?.data)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_VIDEO_LECTURES_DATA_FAILED,
        })
        onFail && onFail(error?.response?.data?.error)
        throw error?.response?.data?.error
      })
  }
}

/** Marks a video as viewed */
export const markAsViewVideo = (data, id) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.MARK_AS_VIEW_EDUCATION_LEARN_INVEST_VIDEO_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/videos?id=${id}`, { ...data }, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.MARK_AS_VIEW_EDUCATION_LEARN_INVEST_VIDEO_SUCCESS,
          payload: res?.data,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.MARK_AS_VIEW_EDUCATION_LEARN_INVEST_VIDEO_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Retrieves data for quizzes */
export const getQuizzesData = (id, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_EDUCATION_LEARN_INVEST_QUIZZES_DATA_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/education/quizzes?id=${id}`, undefined, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_QUIZZES_DATA_SUCCESS,
          payload: res?.data,
        })
        onSuccess && onSuccess(res?.data)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_QUIZZES_DATA_FAILED,
        })
        onFail && onFail(error?.response?.data?.error)
        throw error?.response?.data?.error
      })
  }
}

/** Retrieves detailed information about a specific quiz */
export const getQuizDetails = (id, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_EDUCATION_LEARN_INVEST_QUIZ_DETAILS_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/education/quiz-detail?id=${id}`, undefined, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_QUIZ_DETAILS_SUCCESS,
          payload: res?.data,
        })
        onSuccess && onSuccess(res?.data)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_QUIZ_DETAILS_FAILED,
        })
        onFail && onFail(error?.response?.data?.error)
        throw error?.response?.data?.error
      })
  }
}

/** Submits quiz results to the server */
export const postQuizResult = (id, data) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.POST_EDUCATION_LEARN_INVEST_QUIZ_RESULT_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/quiz-results?id=${id}`, data, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.POST_EDUCATION_LEARN_INVEST_QUIZ_RESULT_SUCCESS,
          payload: res?.data,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.POST_EDUCATION_LEARN_INVEST_QUIZ_RESULT_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Retrieves data for exams */
export const getExamsData = () => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_EDUCATION_LEARN_INVEST_EXAMS_DATA_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/education/get-exams`, undefined, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_EXAMS_DATA_SUCCESS,
          payload: res?.data,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_EXAMS_DATA_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Retrieves detailed information about a specific exam */
export const getExamDetails = (id, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_EDUCATION_LEARN_INVEST_EXAM_DETAILS_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/education/exam-detail?id=${id}`, undefined, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_EXAM_DETAILS_SUCCESS,
          payload: res?.data,
        })
        onSuccess && onSuccess(res?.data)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_EDUCATION_LEARN_INVEST_EXAM_DETAILS_FAILED,
        })
        onFail && onFail(error?.response?.data?.error)
        throw error?.response?.data?.error
      })
  }
}

/** Submits exam results to the server */
export const postExamResult = (id, data) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.POST_EDUCATION_LEARN_INVEST_EXAM_RESULT_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/exam-results?id=${id}`, data, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.POST_EDUCATION_LEARN_INVEST_EXAM_RESULT_SUCCESS,
          payload: res?.data,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.POST_EDUCATION_LEARN_INVEST_EXAM_RESULT_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Fetches count of unread notifications */
export const fetchUnreadNotificationCount = (onSuccess = () => {}, onFail = () => {}) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.FETCH_EDUCATION_LEARN_INVEST_UNREAD_NOTIFICATION_COUNT_INIT,
    })
    await api
      .post(
        `${process.env.REACT_APP_API_URL}/education/notification-dropdown`,
        { is_clicked: false },
        'learnInvest',
      )
      .then(res => {
        dispatch({
          type: actionTypes.FETCH_EDUCATION_LEARN_INVEST_UNREAD_NOTIFICATION_COUNT_SUCCESS,
          payload: res,
        })
        onSuccess && onSuccess(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.FETCH_EDUCATION_LEARN_INVEST_UNREAD_NOTIFICATION_COUNT_FAILED,
        })
        onFail && onFail(error)
        throw error?.response?.data?.error
      })
  }
}

/** Fetches list of unread notifications */
export const fetchUnreadNotifications = () => {
  return async dispatch => {
    dispatch({
      type: actionTypes.FETCH_EDUCATION_LEARN_INVEST_UNREAD_NOTIFICATIONS_INIT,
    })
    await api
      .post(
        `${process.env.REACT_APP_API_URL}/education/notification-dropdown`,
        { is_clicked: true },
        'learnInvest',
      )
      .then(res => {
        dispatch({
          type: actionTypes.FETCH_EDUCATION_LEARN_INVEST_UNREAD_NOTIFICATIONS_SUCCESS,
          payload: res,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.FETCH_EDUCATION_LEARN_INVEST_UNREAD_NOTIFICATIONS_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Clears all notifications */
export const clearNotifications = () => {
  return async dispatch => {
    dispatch({
      type: actionTypes.CLEAR_EDUCATION_LEARN_INVEST_NOTIFICATIONS_INIT,
    })
    await api
      .post(
        `${process.env.REACT_APP_API_URL}/education/notification-dropdown`,
        {
          is_clicked: true,
          clear: true,
        },
        'learnInvest',
      )
      .then(res => {
        dispatch({
          type: actionTypes.CLEAR_EDUCATION_LEARN_INVEST_NOTIFICATIONS_SUCCESS,
          payload: res,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.CLEAR_EDUCATION_LEARN_INVEST_NOTIFICATIONS_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Fetches paginated list of notifications */
export const fetchNotifications = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.FETCH_EDUCATION_LEARN_INVEST_NOTIFICATIONS_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/notifications`, data, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.FETCH_EDUCATION_LEARN_INVEST_NOTIFICATIONS_SUCCESS,
          payload: res,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.FETCH_EDUCATION_LEARN_INVEST_NOTIFICATIONS_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Marks the education tour as completed */
export const completeEducationTour = () => {
  return async dispatch => {
    dispatch({
      type: actionTypes.COMPLETE_EDUCATION_TOUR_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/education/tour-completed`, undefined, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.COMPLETE_EDUCATION_TOUR_SUCCESS,
          payload: res,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.COMPLETE_EDUCATION_TOUR_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Resends email confirmation link to user */
export const resendEmailConfirmLink = () => {
  return async dispatch => {
    await api
      .get(`${process.env.REACT_APP_API_URL}/education/email-confirmation-link`, undefined, 'learnInvest')
      .then(res => {
        return
      })
      .catch(error => {
        throw error?.response?.data?.error
      })
  }
}

/** Starts a new learner session */
export const startLearnerSession = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.START_LEARNER_SESSION_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/start-learner-session`, data, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.START_LEARNER_SESSION_SUCCESS,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.START_LEARNER_SESSION_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Updates an existing learner session */
export const updateLearnerSession = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_LEARNER_SESSION_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/education/update-learner-session`, data, 'learnInvest')
      .then(res => {
        dispatch({
          type: actionTypes.UPDATE_LEARNER_SESSION_SUCCESS,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_LEARNER_SESSION_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Ends the current learner session */
export const endLearnerSession = () => {
  return async dispatch => {
    await api
      .get(`${process.env.REACT_APP_API_URL}/education/end-learner-session`, undefined, 'learnInvest')
      .then(res => {
        return
      })
      .catch(error => {
        throw error?.response?.data?.error
      })
  }
}
